import React from 'react';
import { Wallet } from 'lucide-react';

export function AuthWalletHint({ title, children }) {
  return (
    <div className="rounded-xl border border-dashed border-brand-gold bg-brand-gold-light/10 p-4 text-sm text-gray-600">
      <div className="flex items-center gap-2 font-medium text-brand-red">
        <Wallet className="h-4 w-4" />
        {title}
      </div>
      <p className="mt-2">{children}</p>
    </div>
  );
}
